/*Global*/
import logo from '../assets/Logo/Logo.png';


/*Home*/ 
import home1 from '../assets/Home/Home-1.jpg';
import home2 from '../assets/Home/Home-2.jpg';
import home3 from '../assets/Home/Home-3.jpg';


/*Partners*/
import partner1 from '../assets/Partners/Partner-1.png';
import partner2 from '../assets/Partners/Partner-2.png';
import partner3 from '../assets/Partners/Partner-3.png';
import partner4 from '../assets/Partners/Partner-4.png';
import partner5 from '../assets/Partners/Partner-5.png';
import partner6 from '../assets/Partners/Partner-6.png';
import partner7 from '../assets/Partners/Partner-7.png';
import partner8 from '../assets/Partners/Partner-8.png';


/*Mission*/ 
import mobileApp from '../assets/App/Mobile-App.png';
import appStoreBtn from '../assets/App/App-Store.png';
import playStoreBtn from '../assets/App/Play-Store.png';


/*About*/ 
import about1 from '../assets/About/About-1.jpg';
import about2 from '../assets/About/About-2.jpg';
import about3 from '../assets/About/About-3.jpg';


/*Team*/
import team1 from '../assets/Team/Team-1.jpg';
import team2 from '../assets/Team/Team-2.jpg';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-4.jpg';


/*Testimonials*/
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';


/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';


/*Gallery*/
import gallery1 from '../assets/Gallery/Gallery-1.jpg';
import gallery2 from '../assets/Gallery/Gallery-2.jpg';
import gallery3 from '../assets/Gallery/Gallery-3.jpg';
import gallery4 from '../assets/Gallery/Gallery-4.jpg';
import gallery5 from '../assets/Gallery/Gallery-5.jpg';
import gallery6 from '../assets/Gallery/Gallery-6.jpg';
import gallery7 from '../assets/Gallery/Gallery-7.jpg';
import gallery8 from '../assets/Gallery/Gallery-8.jpg';
import gallery9 from '../assets/Gallery/Gallery-9.jpg';


/*Pricing*/
import plan1 from '../assets/Pricing/Plan-1.jpg';
import plan2 from '../assets/Pricing/Plan-2.jpg';
import plan3 from '../assets/Pricing/Plan-3.jpg';


/*Careers*/
import careerIntro from '../assets/Career/Intro/Intro.jpg';
import position1 from '../assets/Career/Positions/Position-1.jpg';
import position2 from '../assets/Career/Positions/Position-2.jpg';
import position3 from '../assets/Career/Positions/Position-3.jpg';
import position4 from '../assets/Career/Positions/Position-4.jpg';
import position5 from '../assets/Career/Positions/Position-5.jpg';
import position6 from '../assets/Career/Positions/Position-6.jpg';


/*Taxis*/ 
import taxi1Gallery1 from '../assets/Taxi/Taxis/Taxi-1.jpg';
import taxi1Gallery2 from '../assets/Taxi/Taxis/Taxi-2.jpg';
import taxi1Gallery3 from '../assets/Taxi/Taxis/Taxi-3.jpg';
import taxi1Gallery4 from '../assets/Taxi/Taxis/Taxi-4.jpg';
import taxi1Review1 from '../assets/Taxi/Reviews/Pic-1.jpg';
import taxi1Review2 from '../assets/Taxi/Reviews/Pic-2.jpg';

import taxi2Gallery1 from '../assets/Taxi/Taxis/Taxi-2.jpg';
import taxi2Gallery2 from '../assets/Taxi/Taxis/Taxi-3.jpg';
import taxi2Gallery3 from '../assets/Taxi/Taxis/Taxi-4.jpg';
import taxi2Gallery4 from '../assets/Taxi/Taxis/Taxi-5.jpg';
import taxi2Review1 from '../assets/Taxi/Reviews/Pic-1.jpg';
import taxi2Review2 from '../assets/Taxi/Reviews/Pic-2.jpg';

import taxi3Gallery1 from '../assets/Taxi/Taxis/Taxi-3.jpg';
import taxi3Gallery2 from '../assets/Taxi/Taxis/Taxi-4.jpg';
import taxi3Gallery3 from '../assets/Taxi/Taxis/Taxi-5.jpg';
import taxi3Gallery4 from '../assets/Taxi/Taxis/Taxi-6.jpg';
import taxi3Review1 from '../assets/Taxi/Reviews/Pic-1.jpg';
import taxi3Review2 from '../assets/Taxi/Reviews/Pic-2.jpg';

import taxi4Gallery1 from '../assets/Taxi/Taxis/Taxi-4.jpg';
import taxi4Gallery2 from '../assets/Taxi/Taxis/Taxi-5.jpg';
import taxi4Gallery3 from '../assets/Taxi/Taxis/Taxi-6.jpg';
import taxi4Gallery4 from '../assets/Taxi/Taxis/Taxi-1.jpg';
import taxi4Review1 from '../assets/Taxi/Reviews/Pic-1.jpg';
import taxi4Review2 from '../assets/Taxi/Reviews/Pic-2.jpg';

import taxi5Gallery1 from '../assets/Taxi/Taxis/Taxi-5.jpg';
import taxi5Gallery2 from '../assets/Taxi/Taxis/Taxi-6.jpg';
import taxi5Gallery3 from '../assets/Taxi/Taxis/Taxi-1.jpg';
import taxi5Gallery4 from '../assets/Taxi/Taxis/Taxi-2.jpg';
import taxi5Review1 from '../assets/Taxi/Reviews/Pic-1.jpg';
import taxi5Review2 from '../assets/Taxi/Reviews/Pic-2.jpg';

import taxi6Gallery1 from '../assets/Taxi/Taxis/Taxi-6.jpg';
import taxi6Gallery2 from '../assets/Taxi/Taxis/Taxi-1.jpg';
import taxi6Gallery3 from '../assets/Taxi/Taxis/Taxi-2.jpg';
import taxi6Gallery4 from '../assets/Taxi/Taxis/Taxi-3.jpg';
import taxi6Review1 from '../assets/Taxi/Reviews/Pic-1.jpg';
import taxi6Review2 from '../assets/Taxi/Reviews/Pic-2.jpg';


/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Service-Gallery/2.jpg';


/*case*/
import case1 from '../assets/Case-Study/Case-Studies/Case-1.jpg';
import case1Gallery1 from '../assets/Case-Study/Case-Gallery/1.jpg';
import case1Gallery2 from '../assets/Case-Study/Case-Gallery/2.jpg';
import case1Gallery3 from '../assets/Case-Study/Case-Gallery/3.jpg';
import case1Gallery4 from '../assets/Case-Study/Case-Gallery/4.jpg';
import case1Gallery5 from '../assets/Case-Study/Case-Gallery/5.jpg';
import case1Gallery6 from '../assets/Case-Study/Case-Gallery/6.jpg';

import case2 from '../assets/Case-Study/Case-Studies/Case-2.jpg';
import case2Gallery1 from '../assets/Case-Study/Case-Gallery/1.jpg';
import case2Gallery2 from '../assets/Case-Study/Case-Gallery/2.jpg';
import case2Gallery3 from '../assets/Case-Study/Case-Gallery/3.jpg';
import case2Gallery4 from '../assets/Case-Study/Case-Gallery/4.jpg';
import case2Gallery5 from '../assets/Case-Study/Case-Gallery/5.jpg';
import case2Gallery6 from '../assets/Case-Study/Case-Gallery/6.jpg';

import case3 from '../assets/Case-Study/Case-Studies/Case-3.jpg';
import case3Gallery1 from '../assets/Case-Study/Case-Gallery/1.jpg';
import case3Gallery2 from '../assets/Case-Study/Case-Gallery/2.jpg';
import case3Gallery3 from '../assets/Case-Study/Case-Gallery/3.jpg';
import case3Gallery4 from '../assets/Case-Study/Case-Gallery/4.jpg';
import case3Gallery5 from '../assets/Case-Study/Case-Gallery/5.jpg';
import case3Gallery6 from '../assets/Case-Study/Case-Gallery/6.jpg';

import case4 from '../assets/Case-Study/Case-Studies/Case-4.jpg';
import case4Gallery1 from '../assets/Case-Study/Case-Gallery/1.jpg';
import case4Gallery2 from '../assets/Case-Study/Case-Gallery/2.jpg';
import case4Gallery3 from '../assets/Case-Study/Case-Gallery/3.jpg';
import case4Gallery4 from '../assets/Case-Study/Case-Gallery/4.jpg';
import case4Gallery5 from '../assets/Case-Study/Case-Gallery/5.jpg';
import case4Gallery6 from '../assets/Case-Study/Case-Gallery/6.jpg';

import case5 from '../assets/Case-Study/Case-Studies/Case-5.jpg';
import case5Gallery1 from '../assets/Case-Study/Case-Gallery/1.jpg';
import case5Gallery2 from '../assets/Case-Study/Case-Gallery/2.jpg';
import case5Gallery3 from '../assets/Case-Study/Case-Gallery/3.jpg';
import case5Gallery4 from '../assets/Case-Study/Case-Gallery/4.jpg';
import case5Gallery5 from '../assets/Case-Study/Case-Gallery/5.jpg';
import case5Gallery6 from '../assets/Case-Study/Case-Gallery/6.jpg';

import case6 from '../assets/Case-Study/Case-Studies/Case-6.jpg';
import case6Gallery1 from '../assets/Case-Study/Case-Gallery/1.jpg';
import case6Gallery2 from '../assets/Case-Study/Case-Gallery/2.jpg';
import case6Gallery3 from '../assets/Case-Study/Case-Gallery/3.jpg';
import case6Gallery4 from '../assets/Case-Study/Case-Gallery/4.jpg';
import case6Gallery5 from '../assets/Case-Study/Case-Gallery/5.jpg';
import case6Gallery6 from '../assets/Case-Study/Case-Gallery/6.jpg';


/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

/*Shop*/
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/1.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/1.jpg';
import product8Gallery4 from '../assets/Shop/Products/2.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/11.jpg';
import product9Gallery4 from '../assets/Shop/Products/12.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/15.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/15.jpg';
import product13Gallery4 from '../assets/Shop/Products/1.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/15.jpg';
import product14Gallery3 from '../assets/Shop/Products/1.jpg';
import product14Gallery4 from '../assets/Shop/Products/2.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product15Gallery1 from '../assets/Shop/Products/15.jpg';
import product15Gallery2 from '../assets/Shop/Products/1.jpg';
import product15Gallery3 from '../assets/Shop/Products/2.jpg';
import product15Gallery4 from '../assets/Shop/Products/3.jpg';
import product15Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product15Review2 from '../assets/Shop/Reviews/Pic-2.jpg';



const images = {

    /*Global*/
    logo,

    /*Home*/
    home1,
    home2,
    home3,

    /*Partners*/
    partner1,
    partner2,
    partner3,
    partner4,
    partner5,
    partner6,
    partner7,
    partner8,

    /*About*/
    about1,
    about2,
    about3,

    /*Team*/
    team1,
    team2,
    team3, 
    team4,

    /*Testimonials*/
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*FAQs*/ 
    FAQs,

    /*Gallery*/
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,

    /*Pricing*/
    plan1,
    plan2,
    plan3,


    /*Career Introduction*/
    careerIntro,

    /*Positions*/
    position1,
    position2,
    position3,
    position4,
    position5,
    position6,

    /*Cars*/
    taxi1Gallery1,
    taxi1Gallery2,
    taxi1Gallery3,
    taxi1Gallery4,
    taxi1Review1,
    taxi1Review2,

    taxi2Gallery1,
    taxi2Gallery2,
    taxi2Gallery3,
    taxi2Gallery4,
    taxi2Review1,
    taxi2Review2,

    taxi3Gallery1,
    taxi3Gallery2,
    taxi3Gallery3,
    taxi3Gallery4,
    taxi3Review1,
    taxi3Review2,

    taxi4Gallery1,
    taxi4Gallery2,
    taxi4Gallery3,
    taxi4Gallery4,
    taxi4Review1,
    taxi4Review2,

    taxi5Gallery1,
    taxi5Gallery2,
    taxi5Gallery3,
    taxi5Gallery4,
    taxi5Review1,
    taxi5Review2,

    taxi6Gallery1,
    taxi6Gallery2,
    taxi6Gallery3,
    taxi6Gallery4,
    taxi6Review1,
    taxi6Review2,


    /*service*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*case*/
    case1,
    case1Gallery1,
    case1Gallery2,
    case1Gallery3,
    case1Gallery4,
    case1Gallery5,
    case1Gallery6,

    case2,
    case2Gallery1,
    case2Gallery2,
    case2Gallery3,
    case2Gallery4,
    case2Gallery5,
    case2Gallery6,

    case3,
    case3Gallery1,
    case3Gallery2,
    case3Gallery3,
    case3Gallery4,
    case3Gallery5,
    case3Gallery6,

    case4,
    case4Gallery1,
    case4Gallery2,
    case4Gallery3,
    case4Gallery4,
    case4Gallery5,
    case4Gallery6,

    case5,
    case5Gallery1,
    case5Gallery2,
    case5Gallery3,
    case5Gallery4,
    case5Gallery5,
    case5Gallery6,

    case6,
    case6Gallery1,
    case6Gallery2,
    case6Gallery3,
    case6Gallery4,
    case6Gallery5,
    case6Gallery6,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

    product15Gallery1,
    product15Gallery2,
    product15Gallery3,
    product15Gallery4,
    product15Review1,
    product15Review2,

    /*Mission*/
    mobileApp,
    appStoreBtn,
    playStoreBtn

};

export default images;